import React from "react"
import PropTypes from "prop-types"
import clsx from "clsx"

import BgImage from "./background-image"
import { Typography, makeStyles, Box } from "@material-ui/core"

import colors from "../utility/colors"

const useStyles = makeStyles(theme => ({
  bgImage: {
    height: "300px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      height: "550px",
    },
    "&::before, &::after": {
      backgroundPosition: "center",
    },
    "&.about": {
      [theme.breakpoints.down("sm")]: {
        "&::before, &::after": {
          backgroundPosition: "right 0",
        },
      },
    },
  },
  typography: {
    color: colors.grey[400],
    fontSize: `${30 / theme.typography.fontSize}rem`,
    fontWeight: 300,
    fontStyle: "italic",
    [theme.breakpoints.down("sm")]: {
      fontSize: `${25 / theme.typography.fontSize}rem`,
    },
  },
  author: {
    fontSize: `${20 / theme.typography.fontSize}rem`,
    [theme.breakpoints.down("sm")]: {
      fontSize: `${15 / theme.typography.fontSize}rem`,
    },
  },
}))

const Quote = props => {
  const { quote, author, imgName, ...rest } = props
  const classes = useStyles(props)
  const authorClassName = clsx(classes.typography, classes.author)

  return (
    <BgImage
      className={classes.bgImage}
      data-section="quote"
      imgName={imgName}
      {...rest}
    >
      <Box maxWidth="1240px" px={3}>
        <Typography className={classes.typography}>{quote}</Typography>
        <Typography className={authorClassName} align="right">
          {author}
        </Typography>
      </Box>
    </BgImage>
  )
}

Quote.propTypes = {
  quote: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
  imgName: PropTypes.string.isRequired,
}

export default Quote
